// Shared "Show entries + Showing X to Y of Z" footer with ellipsis pagination,
// matching the style used on the My Task listing page.
export default function PaginationBar({
  page,
  pageSize,
  setPage,
  setPageSize,
  totalRecords,
  pageSizeOptions = [10, 25, 50],
}) {
  const totalPages = Math.max(1, Math.ceil(totalRecords / pageSize));

  return (
    <div className="flex items-center justify-between mt-3 flex-wrap gap-3">
      {/* Left — Show entries */}
      <div className="flex items-center gap-2 text-xs text-slate-500 flex-wrap">
        <span>Show</span>
        <select
          value={pageSize}
          onChange={e => { setPageSize(Number(e.target.value)); setPage(1); }}
          className="border border-gray-200 rounded px-1.5 py-1 text-xs text-slate-600 bg-white cursor-pointer focus:outline-none focus:border-violet-400"
        >
          {pageSizeOptions.map(n => <option key={n} value={n}>{n}</option>)}
        </select>
        <span>entries</span>
        <span className="ml-2 text-slate-400">
          Showing <b className="text-gray-700">{totalRecords === 0 ? 0 : (page - 1) * pageSize + 1}</b> to{" "}
          <b className="text-gray-700">{Math.min(page * pageSize, totalRecords)}</b> of{" "}
          <b className="text-gray-700">{totalRecords}</b> entries
        </span>
      </div>

      {/* Right — Pagination buttons */}
      <div className="flex items-center gap-1">
        <button
          disabled={page === 1}
          onClick={() => setPage(page - 1)}
          className="px-3 py-1 rounded border text-xs cursor-pointer font-medium transition-colors bg-white border-gray-200 text-slate-500 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed"
        >
          Previous
        </button>

        {(() => {
          const pages = [];
          const delta = 2;
          const left  = Math.max(2, page - delta);
          const right = Math.min(totalPages - 1, page + delta);

          pages.push(1);
          if (left > 2) pages.push("...");
          for (let i = left; i <= right; i++) pages.push(i);
          if (right < totalPages - 1) pages.push("...");
          if (totalPages > 1) pages.push(totalPages);

          return pages.map((p, idx) =>
            p === "..." ? (
              <span key={`dots-${idx}`} className="px-2 py-1 text-xs text-slate-400">...</span>
            ) : (
              <button
                key={p}
                onClick={() => setPage(p)}
                className={`px-2.5 py-1 rounded border text-xs min-w-[32px] cursor-pointer font-medium transition-colors ${
                  p === page
                    ? "bg-[linear-gradient(135deg,#7C3AED,#6D28D9)] text-white border-transparent"
                    : "bg-white border-[#E5E7EB] text-[#6B7280]"
                }`}
              >
                {p}
              </button>
            )
          );
        })()}

        <button
          disabled={page === totalPages}
          onClick={() => setPage(page + 1)}
          className="px-3 py-1 rounded border text-xs cursor-pointer font-medium transition-colors bg-white border-gray-200 text-slate-500 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed"
        >
          Next
        </button>
      </div>
    </div>
  );
}
